import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  companyLogoData: null,
  isSuccess: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.UPDATE_COMPANY_LOGO_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
      };
    case actionConstants.UPDATE_COMPANY_LOGO_SUCCESS:
      return {
        ...state,
        companyLogoData: action.message,
        isfetching: false,
        isSuccess: true,
      };
    case actionConstants.UPDATE_COMPANY_LOGO_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
      };
    case actionConstants.UPDATE_COMPANY_LOGO_RESET:
      return {
        ...state,
        companyLogoData: null,
        isSuccess: false,
        error: '',
      };
    default:
      return state;
  }
};
